/* eslint-disable global-require */
if (!window.DEBUG) {
  __webpack_public_path__ = window.publicAssetsPath // eslint-disable-line camelcase
}
